import { render, staticRenderFns } from "./AccProductReactionCreateModal.vue?vue&type=template&id=b3627674"
import script from "./AccProductReactionCreateModal.vue?vue&type=script&lang=js"
export * from "./AccProductReactionCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports